"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowHeader = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var back_button_1 = require("./back-button");
var StyledNavigation = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: sticky;\n  background-color: #ffffff;\n  border-bottom: 1px solid ", ";\n"], ["\n  position: sticky;\n  background-color: #ffffff;\n  border-bottom: 1px solid ", ";\n"])), core_ui_1.colors.steel[200]);
var StyledHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  top: 0;\n  z-index: 10;\n  padding: 22px 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  top: 0;\n  z-index: 10;\n  padding: 22px 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n"])));
function WorkflowHeader(_a) {
    var title = _a.title, backTooltipText = _a.backTooltipText, onBack = _a.onBack;
    return (react_1.default.createElement(StyledNavigation, null,
        react_1.default.createElement(StyledHeader, null,
            react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-start" },
                react_1.default.createElement(core_ui_1.Stack, { gap: 24 },
                    react_1.default.createElement(back_button_1.BackButton, { tooltipText: backTooltipText, onClick: onBack }))),
            react_1.default.createElement(core_ui_1.Spacing, { width: 24 }),
            react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "space-between", width: "100%" },
                react_1.default.createElement(core_ui_1.Text, { size: "large", color: "dark", weight: 500 }, title)))));
}
exports.WorkflowHeader = WorkflowHeader;
var templateObject_1, templateObject_2;
